import { Sport } from '#src/__generated__/globalTypes.ts';

import baseSetBackgroundImage from './assets/background/background.webp';
import footballComposeTeam from './assets/compose-team/FootballFieldBackground.webp';
import nbaComposeTeam from './assets/compose-team/NBAFieldBackground.webp';
import playFootballBackgroundImage from './assets/footballBackground.webp';
import playNbaBackgroundImage from './assets/nbaBackground.webp';
import onboardingBackground from './assets/onboarding-background.webp';
import replayDialogFootballBackground from './assets/replayDialog/football.webp';
import replayDialogNBABackground from './assets/replayDialog/nba.webp';
import playVoucherIcon from './assets/voucher.svg';
import commonPacksLogoImage from './assets/wntr-logo.svg';

type SetPlaySportAssets = {
  backgroundImage: string;
};
const DEFAULT_SET_PLAY_SPORT_ASSETS: SetPlaySportAssets = {
  backgroundImage: playFootballBackgroundImage,
};
const SET_PLAY_SPORT_ASSETS: Partial<Record<Sport, SetPlaySportAssets>> = {
  [Sport.FOOTBALL]: DEFAULT_SET_PLAY_SPORT_ASSETS,
  [Sport.NBA]: {
    backgroundImage: playNbaBackgroundImage,
  },
};

export const SET_BASE = {
  displayName: 'Common',
  slug: 'common-base-set',
  colorTheme: undefined,
  supportedSports: [Sport.FOOTBALL, Sport.NBA] as const,
  cardEditionSlugs: ['base'] as const,
  skins: [],
  colors: {
    main: 'var(--c-common)',
    swipeEffectColor: '#e8ecee',
    mainRGB: [0, 243, 235] satisfies [number, number, number],
  },
  visual: {
    board: {
      mobileDecoration: null,
    },
    commonPacks: {
      logoImage: commonPacksLogoImage,
    },
    cardReveal: {
      swipeIconImage: null,
      background: {
        background: `
          linear-gradient(to bottom, transparent 0%, transparent 70%, #2A0F49 100%),
          linear-gradient(to bottom, transparent 0%, #2A0F49 100%),
          linear-gradient(to bottom, #2A0F49 0%, #9464FF 100%)
        `,
        backgroundBlendMode: 'normal, normal, normal',
      },
      videoSources: null,
      newEffectColor: null,
    },
    seasonCountdown: null,
    brand: {
      logoImage: null,
      SetLogoImg: null,
      SetIcon: () => null,
    },
    play: {
      getSportAssets: (sport: Sport) =>
        SET_PLAY_SPORT_ASSETS[sport] || DEFAULT_SET_PLAY_SPORT_ASSETS,
      voucherIcon: playVoucherIcon,
    },
    replayDialog: {
      background: {
        [Sport.FOOTBALL]: replayDialogFootballBackground,
        [Sport.NBA]: replayDialogNBABackground,
        [Sport.BASEBALL]: undefined,
      },
    },
    welcomePackDialog: null,
    welcomeBackDialog: null,
    composeTeam: {
      [Sport.FOOTBALL]: footballComposeTeam,
      [Sport.NBA]: nbaComposeTeam,
      [Sport.BASEBALL]: undefined,
    },
    squad: null,
    onboardingBackground: {
      background: `
        linear-gradient(
          to bottom,
          rgba(var(--c-rgb-set-surface-tertiary), 0.7),
          rgba(var(--c-rgb-set-surface-tertiary), 0.7)
        ),
        url(${onboardingBackground}) no-repeat center / cover`,
      backgroundBlendMode: 'multiply, normal',
    },
  },
  background: {
    background: `
    linear-gradient(0deg, rgba(0, 0, 0, 0.50) 0%, rgba(0, 0, 0, 0.50) 100%),
    linear-gradient(0deg, #5776FF 0%, #5776FF 100%),
    url("${baseSetBackgroundImage}") center / cover repeat
  `,
    backgroundBlendMode: 'normal, hue, normal',
  },
} as const;
